import { computed, signal } from '@angular/core';
import * as i0 from "@angular/core";
export class AgentSidePanelStateService {
    constructor() {
        this.screen = signal('welcome', ...(ngDevMode ? [{ debugName: "screen" }] : []));
        this.isWelcomeScreen = computed(() => this.screen() === 'welcome', ...(ngDevMode ? [{ debugName: "isWelcomeScreen" }] : []));
        this.isChatScreen = computed(() => this.screen() === 'chat', ...(ngDevMode ? [{ debugName: "isChatScreen" }] : []));
    }
}
AgentSidePanelStateService.ɵfac = function AgentSidePanelStateService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSidePanelStateService)(); };
AgentSidePanelStateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentSidePanelStateService, factory: AgentSidePanelStateService.ɵfac, providedIn: 'root' });
